module.exports = __webpack_public_path__ + "img/download_header.42abb9da.svg";